export default {"src":"/_next/static/media/postepay.99831dad.svg","height":8,"width":37,"blurWidth":0,"blurHeight":0};